module.exports = __webpack_public_path__ + "vrplayerstatic/media/Play.99d14da3.svg";